export const environment = {
  appName: 'Agente View',
  home: '/panel',
  production: false,
  api: 'https://dev-api-agentview.logame.app',
  url: 'https://dev-agentview.logame.app',

  socket: {
    key: "mNKxhCrvOIDjXjfSP3mAVWhm9CBqe3Th",
    wsHost: "socket-dev-agentview.logame.app",
    wsPort: 443,
    wssHost: "socket-dev-agentview.logame.app",
    wssPort: 443,
    forceTLS: true,
  }
};
